// Keep external booking destinations centralized so every CTA stays consistent.
export const CONSULTATION_URL = 'https://calendly.com/johnpaulbare/30min';
